import * as React from 'react';
import {DropDownRouteData, HeaderMenuData} from "../../../../navigation/route/HeaderRoutes";
import HeaderSubMenu from "./HeaderSubMenu";

const classNames = require('classnames');

interface ComponentProps {
	/**
	 * Menu item id.
	 */
	itemId: number;
	/**
	 * Menu item on hover callback.
	 */
	onMouseOver: (itemId: number) => void
	/**
	 * Menu item on hover callback.
	 */
	onMouseOut: () => void
	/**
	 * On item click callback,
	 * @param url Route url.
	 */
	onClick: (url: string) => void
	/**
	 * Indicates if menu item is has expanded drop down menu.
	 */
	isExpanded: boolean;
	/**
	 * Indicates if menu item is active.
	 */
	isActive: boolean;
	/**
	 * Route to handle.
	 */
	route: HeaderMenuData
	/**
	 * Handling non expandable menu item
	 */
	onNonExpandableItemClick: (route: string) => void
	/**
	 * Indicates if menu item is clickable.
	 */
	clickableItem?: boolean
	/**
	 * Opens or closes the submenu on click, where there is no hover to do it.
	 */
	onToggle?: (itemId: number) => void
}

export default class HeaderMenuItem extends React.Component<ComponentProps, {}> {

	render() {
		const classFromProps = classNames({
			"c-header-menu_item": true,
			"is-active": this.props.isActive,
			"has-submenu": !this.props.clickableItem,
			"is-expanded": !this.props.clickableItem && this.props.isExpanded
		});

		return (
			<li className={classFromProps}
				onMouseOver={() => this.props.onMouseOver(this.props.itemId)}
				onMouseOut={this.props.onMouseOut}
				onClick={this.onClick}>
				<span className={"c-header-menu_item_link"}>
					{this.props.route.label}
				</span>
				{!this.props.clickableItem && this.props.isExpanded &&
				<HeaderSubMenu routes={this.props.route.subRoutes}
							   onItemClick={(url) => this.props.onClick(url)}/>}
			</li>
		);
	}

	onClick = () => {
		if (this.props.clickableItem) {
			this.props.onNonExpandableItemClick(this.props.route.route);
		}
		else if (this.props.onToggle) {
			this.props.onToggle(this.props.itemId);
		}
	}
}